import * as fileTypes from '../types/File';
import * as fileValidator from './Validators/FileValidator';
import * as errorActions from './Error';
import {PARSE_FILE_ERROR} from '../const/ErrorMessages/FileErrorMessages';
import * as complaintPositionAction from './ComplaintPosition';
import {openFilePreviewModal, hideModal} from './Modal';

export function changeSelectedFile(file) {
    return {
        type: fileTypes.FILE_CHANGE_SELECTED_FILE,
        payload: file
    };
}

function afterFileParseCallback(parsedFile,filesTargetName) {
    try {
        fileValidator.validateFileContent(parsedFile.base64);
        return complaintPositionAction.AddFile(parsedFile,filesTargetName);
    } catch (error) {
        return errorActions.throwNewError("Błąd podpinania pliku", error.message);
    }
}

export function unparseFile(file,filesTargetName) {
    return (dispatch, getState) => {
        const files = getState().complaintPosition.files;
        const purchaseProve = getState().complaintPosition.purchaseProve;
        dispatch(errorActions.clearError());
        try {
            fileValidator.validateThatFileToAddNotExceedMaxFilesNumber(files);
            fileValidator.validateFileType(file);
            fileValidator.validateThatFileToAddNotExistingInAddedFiles(file,files);
            fileValidator.validateThatFileToAddNotExistingInAddedFiles(file,purchaseProve);
            fileValidator.validateFileSize(file, 1048576);
            parseFile(file,afterFileParseCallback, dispatch,filesTargetName);
        } catch (error) {
            return dispatch(errorActions.throwNewError("Błąd podpinania pliku", error.message));
        }
    };
}


function parseFile(file, callback, dispatch,filesTargetName){
  
    let fileReader = new FileReader();
    fileReader.onload = function(e) {
        dispatch(callback({
            name: file.name,
            base64: e.target.result,
        },filesTargetName
        ));
    };
    try {
        fileReader.readAsDataURL(file);
    } catch (error) {
        throw new Error(PARSE_FILE_ERROR);
    }
}

export function openFilePreview(file) {
    return (dispatch) => {
        dispatch(openFilePreviewModal(file));
        return dispatch({ 
            type: fileTypes.FILE_OPEN_FILE_PREVIEW,
            payload: file
        });
    };
}

export function closeFilePreview() {
    return (dispatch) => {
        dispatch(hideModal());
    };
}


// WEBPACK FOOTER //
// ./src/actions/File.js